export default __webpack_public_path__ + "static/media/eye-off.e4f36f6f.svg";